/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Button,
  CircularProgress,
  FormControlLabel,
  FormGroup,
  IconButton,
  InputAdornment,
  Popper,
  Skeleton,
  TextField,
} from '@mui/material';
import athena from '@root/assets/img/aws_services/aws_athena.svg';
import credentialAccessIcon from '@root/assets/svg/Cloud_Events/credential_access.png';
import dataLogo from '@root/assets/svg/Cloud_Events/data-security-logo.svg';
import encryptionLogo from '@root/assets/svg/Cloud_Events/encryption-logo.svg';
import exposedSecretsLogo from '@root/assets/svg/Cloud_Events/exposed-secret.svg';
import highAvailabilityLogo from '@root/assets/svg/Cloud_Events/high-availability.svg';
import { ChevronDown, X } from 'lucide-react';

import attackPreventionLogo from '@root/assets/svg/Cloud_Events/attack-prevention.svg';
import authenticationLogo from '@root/assets/svg/Cloud_Events/authentication.svg';
import availabilityOperationsLogo from '@root/assets/svg/Cloud_Events/availability-operations.svg';
import complianceLogo from '@root/assets/svg/Cloud_Events/compliance.svg';
import documentationLogo from '@root/assets/svg/Cloud_Events/documentation.svg';
import environmentIsolationLogo from '@root/assets/svg/Cloud_Events/environment-isolation.svg';
import governanceHygieneLogo from '@root/assets/svg/Cloud_Events/governance-hygiene.svg';
import identityAccessLogo from '@root/assets/svg/Cloud_Events/identity-access.svg';
import identityLogo from '@root/assets/svg/Cloud_Events/identity-logo.svg';
import informationDisclosureLogo from '@root/assets/svg/Cloud_Events/information-disclosure.svg';
import infrastructureSecurityLogo from '@root/assets/svg/Cloud_Events/infrastructure-security.svg';
import inputValidationLogo from '@root/assets/svg/Cloud_Events/input-validation.svg';
import inventoryManagementLogo from '@root/assets/svg/Cloud_Events/inventory-management.svg';
import lateralMovementLogo from '@root/assets/svg/Cloud_Events/lateral-movement.svg';
import lifecycleManagementLogo from '@root/assets/svg/Cloud_Events/lifecycle-management.svg';
import loggingMonitoringLogo from '@root/assets/svg/Cloud_Events/logging-and-monitoring.svg';
import Malware from '@root/assets/svg/Cloud_Events/malware.svg';
import misconfigurationIcon from '@root/assets/svg/Cloud_Events/misconfigurationlogo.svg';
import networkLogo from '@root/assets/svg/Cloud_Events/network-logo.svg';
import noRiskLogo from '@root/assets/svg/Cloud_Events/no-risk-logo.svg';
import privacyLogo from '@root/assets/svg/Cloud_Events/privacy.svg';
import rateLimitingLogo from '@root/assets/svg/Cloud_Events/rate-limiting.svg';
import resourceManagementLogo from '@root/assets/svg/Cloud_Events/resource-management.svg';
import riskAssessmentLogo from '@root/assets/svg/Cloud_Events/risk-assessment.svg';
import RuntimeLogo from '@root/assets/svg/Cloud_Events/runtimelogo.svg';
import supplyChainLogo from '@root/assets/svg/Cloud_Events/supply-chain.svg';
import thirdPartyLogo from '@root/assets/svg/Cloud_Events/third-party-logo.svg';
import userLogo from '@root/assets/svg/Cloud_Events/user-logo.svg';
import vulnerabilitiesLogo from '@root/assets/svg/Cloud_Events/vulnerabilities-logo.svg';
import vulnerabilityManagementLogo from '@root/assets/svg/Cloud_Events/vulnerability-management.svg';
import workloadHardeningLogo from '@root/assets/svg/Cloud_Events/workload-hardening.svg';
import workloadSecurityLogo from '@root/assets/svg/Cloud_Events/workload-security-logo.svg';
import SearchIcon from '@root/assets/svg/Navigation/SearchIcon';
import accessKey1NotRotatedLogo from '@root/assets/svg/Risk/RiskPriority/access-key1-not-rotated.svg';
import accessKey2NotRotatedLogo from '@root/assets/svg/Risk/RiskPriority/access-key2-not-rotated.svg';
import administratorLogo from '@root/assets/svg/Risk/RiskPriority/admin.svg';
import anomalousLogo from '@root/assets/svg/Risk/RiskPriority/anomalous.svg';
import attackPathLogo from '@root/assets/svg/Risk/RiskPriority/attack_path.svg';
import credentialExposureLogo from '@root/assets/svg/Risk/RiskPriority/credential-exposure.svg';
import crossAccountLogo from '@root/assets/svg/Risk/RiskPriority/cross-account.svg';
import dataAccessLogo from '@root/assets/svg/Risk/RiskPriority/data-access.svg';
import EffectiveAdmin from '@root/assets/svg/Risk/RiskPriority/effective-admin.png';
import environmentAccessLogo from '@root/assets/svg/Risk/RiskPriority/environment-access.svg';
import inactiveLogo from '@root/assets/svg/Risk/RiskPriority/inactive.png';
import infrastructureModificationLogo from '@root/assets/svg/Risk/RiskPriority/infrastructure-modification.svg';
import learningLogo from '@root/assets/svg/Risk/RiskPriority/learning.svg';
import multipleAccessKeysActiveLogo from '@root/assets/svg/Risk/RiskPriority/multiple-access-keys-active.png';
import noMfaLogo from '@root/assets/svg/Risk/RiskPriority/no-mfa.svg';
import operationsLogo from '@root/assets/svg/Risk/RiskPriority/operations.svg';
import overPrivilegedLogo from '@root/assets/svg/Risk/RiskPriority/over-privileged.svg';
import permissionManagementLogo from '@root/assets/svg/Risk/RiskPriority/permission-management.png';
import privilegeEscalationLogo from '@root/assets/svg/Risk/RiskPriority/privilege-escalation.svg';
import priviledgeLogo from '@root/assets/svg/Risk/RiskPriority/privledge.png';
import reconnaissanceLogo from '@root/assets/svg/Risk/RiskPriority/reconnaissance.svg';
import rootUserLogo from '@root/assets/svg/Risk/RiskPriority/root-user.svg';
import threatLogo from '@root/assets/svg/Risk/RiskPriority/threat.svg';
import ComputeIcon from '@root/assets/svg/Service_Category_Icons/Compute.svg';
import ContainersIcon from '@root/assets/svg/Service_Category_Icons/Containers.svg';
import Analytics from '@root/assets/svg/Service_Category_Icons/Data_Analytics.svg';
import Database from '@root/assets/svg/Service_Category_Icons/Database.svg';
import DeveloperIcon from '@root/assets/svg/Service_Category_Icons/Developer_Tools.svg';
import MachineLearningIcon from '@root/assets/svg/Service_Category_Icons/Machine_Learning.svg';
import ManagementToolsIcon from '@root/assets/svg/Service_Category_Icons/Management_Tools.svg';
import NetworkingIcon from '@root/assets/svg/Service_Category_Icons/Networking.svg';
import OperationIcon from '@root/assets/svg/Service_Category_Icons/Operations.svg';
import SecurityIdentityIcon from '@root/assets/svg/Service_Category_Icons/Security_Identity.svg';
import ServerlessIcon from '@root/assets/svg/Service_Category_Icons/Serverless.svg';
import StorageIcon from '@root/assets/svg/Service_Category_Icons/Storage.svg';
import ArtificialIntelligenceIcon from '@root/assets/svg/Top Services Categories/Artificial_Intelligence.svg';
import AWSServiceIcons from '@root/components/awsServiceIcons';
import ComplianceIconMapping from '@root/components/complianceIconMapping';
import CheckBox from '@root/components/v2/ui-elements/CheckBox';
import RegionsFlagIcons from '@root/components/v2/ui-elements/CountryFlagIcons/regionFlagIcons';
import useDebouncedValue from '@root/hooks/useDebouncedValue';
import { useQuery as useQueryURL } from '@root/hooks/useQuery';
import useEnhancedQuery from '@root/query/useEnhancedQuery';
import { isBoolean, isEmpty } from 'lodash';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import NoData from '../common/NoData';
import CountryFlagIcons from '../v2/ui-elements/CountryFlagIcons';
import Tooltip from '../v2/ui-elements/Tooltip';
import './filter.scss';
import ResetButton from './ResetButton';

const active_risk_mapping = {
  ['Data']: dataLogo,
  ['Credential Exposure']: credentialExposureLogo,
  ['Data Exposure']: dataLogo,
  ['Privilege Escalation']: privilegeEscalationLogo,
  ['Reconnaissance']: reconnaissanceLogo,
  ['Privileged']: priviledgeLogo,
  ['Inactive']: inactiveLogo,
  ['Threat']: threatLogo,
  ['Administrator']: administratorLogo,
  ['Admin']: administratorLogo,
  ['Infrastructure Modification']: infrastructureModificationLogo,
  ['Over Privileged']: overPrivilegedLogo,
  ['Data Security']: dataLogo,
  ['Encryption']: encryptionLogo,
  ['Exposed Secrets']: exposedSecretsLogo,
  ['secrets']: exposedSecretsLogo,
  ['Secrets']: exposedSecretsLogo,
  ['Internet Exposed']: exposedSecretsLogo,
  ['Network']: networkLogo,
  ['Network Security']: networkLogo,
  ['Anomalous']: anomalousLogo,
  ['Logging And Monitoring']: loggingMonitoringLogo,
  ['Logging & Monitoring']: loggingMonitoringLogo,
  ['Lateral Movement']: lateralMovementLogo,
  ['High Availability']: highAvailabilityLogo,
  ['Identity']: identityLogo,
  ['User']: userLogo,
  ['Vulnerabilities']: vulnerabilitiesLogo,
  ['NoRisk']: noRiskLogo,
  ['Misconfiguration']: misconfigurationIcon,
  ['Configuration']: misconfigurationIcon,
  ['Malware']: Malware,
  ['Runtime']: RuntimeLogo,
  ['No Mfa']: noMfaLogo,
  ['Cross Account']: crossAccountLogo,
  ['Environment Access']: environmentAccessLogo,
  ['Multiple Access Keys Active']: multipleAccessKeysActiveLogo,
  ['Root User']: rootUserLogo,
  ['Access Key 1 Not Rotated']: accessKey1NotRotatedLogo,
  ['Learning']: learningLogo,
  ['Access Key 2 Not Rotated']: accessKey2NotRotatedLogo,
  ['Attack path']: attackPathLogo,
  ['Operational']: operationsLogo,
  ['Credential Access']: credentialAccessIcon,
  ['Access Control']: credentialAccessIcon,
  ['IAM']: identityLogo,
  ['Effective Admin']: EffectiveAdmin,
  ['Data Access']: dataAccessLogo,
  ['High Privileged']: overPrivilegedLogo,
  ['Misconfigurations']: misconfigurationIcon,
  ['Threats anomaly']: threatLogo,
  ['Anomaly']: anomalousLogo,
  ['Permission Management']: permissionManagementLogo,
  ['Environment Isolation']: environmentIsolationLogo,
  ['Infrastructure Security']: infrastructureSecurityLogo,
  ['Inventory Management']: inventoryManagementLogo,
  ['Resource Management']: resourceManagementLogo,
  ['Rate Limiting']: rateLimitingLogo,
  ['Authentication']: authenticationLogo,
  ['Input Validation']: inputValidationLogo,
  ['Documentation']: documentationLogo,
  ['Attack Prevention']: attackPreventionLogo,
  ['Information Disclosure']: informationDisclosureLogo,
  ['Compliance']: complianceLogo,
  ['Privacy']: privacyLogo,
  ['Lifecycle Management']: lifecycleManagementLogo,
  ['Risk Assessment']: riskAssessmentLogo,
  ['Workload Security']: workloadSecurityLogo,
  ['Third Party']: thirdPartyLogo,
  ['Availability & Operations']: availabilityOperationsLogo,
  ['Availability And Operations']: availabilityOperationsLogo,
  ['Identity & Access']: identityAccessLogo,
  ['Identity And Access']: identityAccessLogo,
  ['Supply Chain']: supplyChainLogo,
  ['Vulnerability Management']: vulnerabilityManagementLogo,
  ['Workload Hardening']: workloadHardeningLogo,
  ['Governance & Hygiene']: governanceHygieneLogo,
  ['Governance And Hygiene']: governanceHygieneLogo,
};

const ignoreRedirectionFields = ['resource_id', 'resource_ids'];

const serviceGridIcons = {
  [`Networking`]: NetworkingIcon,
  ['Artificial Intelligence']: ArtificialIntelligenceIcon,
  ['Operations']: OperationIcon,
  ['Developer Tools']: DeveloperIcon,
  ['Machine Learning']: MachineLearningIcon,
  ['Storage']: StorageIcon,
  ['Compute']: ComputeIcon,
  ['Security & Identity']: SecurityIdentityIcon,
  ['Serverless']: ServerlessIcon,
  ['Management Tools']: ManagementToolsIcon,
  ['Containers']: ContainersIcon,
  ['Data Analytics']: Analytics,
  ['Database']: Database,
  ['Athena']: athena,
};

const PaginatedFilter = ({
  openFilter,
  option,
  selectedFilters,
  setSelectedFilters,
  defaultValue,
  setIsDefaultValue,
  setInventoryTableBreadcrumb,
  fetchFilterPropertyValues,
  isKubernetes = false,
  isInventory = false,
  fromRisk = false,
  isKubernetesInventory = false,
  serviceCategoryList = null,
  totalCount,
  currentTab,
  zIndex = 10,
  filterQueryDependencies,
  enableSelectedFirst = true, // NEW PROP for backward compatibility
  disablePortal = false,
  // Optional. When the owner keeps filter state outside `selectedFilters` too — in the URL, say — it
  // has to clear that itself, so Reset hands the whole job over instead of only emptying the keys it
  // can see here. Callers that do not pass it keep the generic empty-out below.
  onResetFilters,
  // Optional. The `selectedFilters` keys that count as a filter; see `hasActiveFilters`.
  filterKeys,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const buttonRefs = useRef([]);
  const popperRefs = useRef([]);
  const query = useQueryURL();
  const prefdefinedSearchTerm = useMemo(() => {
    return query.get('_currentIdentity') ?? query.get('_res_id');
  }, [query]);
  const [openFilterId, setOpenFilterId] = useState(null);
  const [isAnyPopperOpen, setIsAnyPopperOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState(prefdefinedSearchTerm ?? '');
  const debouncedSearchTerm = useDebouncedValue(searchTerm, 800);
  // True while the user is still typing; the filter query stays disabled until the search settles.
  const isSearchPending = searchTerm !== debouncedSearchTerm;
  const [filterData, setFilterData] = useState({});
  const [pageInfo, setPageInfo] = useState({});
  const [hasMore, setHasMore] = useState({});

  const [currentFilterKey, setCurrentFilterKey] = useState(null);
  const [showSkeletonForNewFilter, setShowSkeletonForNewFilter] = useState(false);
  const [, setIsPaginationLoading] = useState(false);
  const [shouldRefetchFilter, setShouldRefetchFilter] = useState(false);
  // Tracks consecutive auto-advances over duplicate-only pages, per filter, to
  // guard against a backend that returns has_more:true with repeated values forever.
  const autoAdvanceCountRef = useRef({});

  const filterOptions = useMemo(() => {
    if (option) {
      return Object.keys(option)?.map(key => ({
        id: key.toLowerCase().replace(/\s+/g, '_'),
        label: key,
        options: option[key]?.data,
        totalRecords: option[key]?.num_records,
      }));
    }
  }, [option]);

  const createQueryKey = useCallback(
    (filter, page, searchTermParam) => {
      return [
        'filter-data',
        filter.id,
        filter.label,
        page,
        searchTermParam,
        isKubernetesInventory,
        isInventory,
        isKubernetes,
        currentTab,
        filterQueryDependencies,
        selectedFilters,
      ];
    },
    [isKubernetesInventory, isInventory, isKubernetes, currentTab, filterQueryDependencies, selectedFilters],
  );

  const queryFunction = useCallback(
    async ({ queryKey }) => {
      const [
        ,
        filterId,
        filterLabel,
        page,
        searchTermParam,
        isKubernetesInventoryFlag,
        isInventoryFlag,
        isKubernetesFlag,
        currentTabValue,
      ] = queryKey;

      const selectedFiltersParam = selectedFilters;

      if ((fromRisk && filterId === 'risk_category') || !fetchFilterPropertyValues) {
        return null;
      }

      if (page > 1) {
        setIsPaginationLoading(true);
      }

      let params = {};
      if (!isKubernetesInventoryFlag) {
        params = {
          property_keys: [filterLabel],
          page_no: page,
          row_per_page: 20,
          search_key: searchTermParam,
          filter_particular_key:
            searchTermParam && searchTermParam.length > 0 && (query.get('_currentIdentity') || query.get('_res_id'))
              ? `resource_id${query.get('_res_id') && 's'}`
              : filterLabel,
          previous_filter: selectedFiltersParam
            ? Object.entries(selectedFiltersParam)
                .filter(([key, value]) => Array.isArray(value) && value.length > 0 && key !== 'match' && key !== 'sort')
                .map(([key, value]) => ({ [key]: value }))
            : [],
        };
      } else {
        params = {
          property_keys: [filterLabel],
          page_number: page,
          rows_per_page: 20,
          search_key: searchTermParam,
          filter_particular_key: filterLabel,
          currentTab: currentTabValue,
          previous_filter: selectedFiltersParam
            ? Object.entries(selectedFiltersParam)
                .filter(([key, value]) => Array.isArray(value) && value.length > 0 && key !== 'match' && key !== 'sort')
                .map(([key, value]) => ({ [key]: value }))
            : [],
        };
      }
      try {
        const response = await fetchFilterPropertyValues(params);

        const newData = isInventoryFlag
          ? response?.data
            ? response?.data[Object.keys(response?.data)[0]]
            : response?.property_values[Object.keys(response?.property_values)[0]]
          : isKubernetesFlag || isKubernetesInventoryFlag
          ? response?.data[filterId]
          : response?.data?.data
          ? response?.data?.data[Object.keys(response?.data?.data)[0]]
          : response?.data[Object.keys(response?.data)[0]];

        return {
          data: isKubernetesFlag ? newData?.items || [] : newData?.data || [],
          num_records: isKubernetesFlag ? newData?.total : newData?.num_records ?? newData?.num_of_records,
          has_more: isKubernetesFlag ? newData?.items?.length > 0 : newData?.has_more,
          page,
        };
      } finally {
        setIsPaginationLoading(false);
      }
    },
    [fetchFilterPropertyValues, fromRisk, query, selectedFilters],
  );

  const currentQueryKey = openFilterId
    ? createQueryKey(openFilterId, pageInfo[openFilterId.id] || 1, debouncedSearchTerm, selectedFilters)
    : null;

  const {
    data: queryData,
    isLoading: isQueryLoading,
    isFetching: isQueryFetching,
    isSuccess: isQuerySuccess,
  } = useEnhancedQuery(currentQueryKey || ['filter-data', 'none'], queryFunction, {
    enabled:
      !!openFilterId &&
      isAnyPopperOpen &&
      shouldRefetchFilter &&
      !isSearchPending &&
      !(fromRisk && openFilterId?.id === 'risk_category'),
    keepPreviousData: false,
    onSuccess: () => {
      setShouldRefetchFilter(false);
    },
  });

  useEffect(() => {
    const newFilterKey = openFilterId?.id;

    if (newFilterKey && newFilterKey !== currentFilterKey) {
      setCurrentFilterKey(newFilterKey);

      const hasExistingData = filterData[newFilterKey]?.data?.length > 0;
      const hasStaticData = option[filterOptions?.find(f => f.id === newFilterKey)?.label]?.data?.length > 0;

      if (!hasExistingData && !hasStaticData && !(fromRisk && newFilterKey === 'risk_category')) {
        setShowSkeletonForNewFilter(true);
      } else {
        setShowSkeletonForNewFilter(false);
      }
    }
  }, [openFilterId?.id, currentFilterKey, filterData, option, filterOptions, fromRisk]);

  useEffect(() => {
    if (isQuerySuccess || (!isQueryLoading && !isQueryFetching)) {
      setShowSkeletonForNewFilter(false);
    }
  }, [isQuerySuccess, isQueryLoading, isQueryFetching]);

  useEffect(() => {
    if (!queryData || !openFilterId) return;

    const filterId = openFilterId.id;
    // Use the page the response actually belongs to (not pageInfo, which can
    // update a render before the data arrives) as the source of truth.
    const loadedPage = queryData.page || 1;
    const existingData = filterData[filterId]?.data || [];

    let mergedData;
    let addedCount;
    if (loadedPage === 1) {
      mergedData = queryData.data;
      addedCount = queryData.data.length;
    } else {
      // Remove duplicates when appending
      const existingSet = new Set(existingData.map(item => JSON.stringify(item)));
      const newUniqueData = queryData.data.filter(item => !existingSet.has(JSON.stringify(item)));
      addedCount = newUniqueData.length;
      mergedData = [...existingData, ...newUniqueData];
    }

    setFilterData(prev => ({
      ...prev,
      [filterId]: {
        data: mergedData,
        num_records: queryData.num_records,
      },
    }));

    setHasMore(prev => ({
      ...prev,
      [filterId]: queryData.has_more && queryData.data.length > 0,
    }));

    // InfiniteScroll only re-arms its `next` trigger when `dataLength` changes.
    // If a page returns rows but every value is a duplicate of what we already
    // have, the dedup above keeps the length unchanged and the scroll freezes
    // even though has_more is true. Auto-advance past such pages so pagination
    // keeps progressing, capped to avoid looping on a misbehaving backend.
    if (loadedPage > 1 && queryData.has_more && queryData.data.length > 0 && addedCount === 0) {
      const advances = (autoAdvanceCountRef.current[filterId] || 0) + 1;
      autoAdvanceCountRef.current[filterId] = advances;
      // Only act on the page we're actually positioned at, so re-runs triggered
      // by the pageInfo bump below don't double-fire.
      if (advances <= 25 && (pageInfo[filterId] || 1) === loadedPage) {
        setShouldRefetchFilter(true);
        setPageInfo(prev => ({ ...prev, [filterId]: loadedPage + 1 }));
      }
    } else if (addedCount > 0 || loadedPage === 1) {
      autoAdvanceCountRef.current[filterId] = 0;
    }
    // filterData is intentionally omitted from deps: it is written by this effect
    // and including it would re-run the merge against itself.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryData, openFilterId, pageInfo]);

  const fetchMoreData = useCallback((filter, nextPage) => {
    setShouldRefetchFilter(true);
    setPageInfo(prev => ({ ...prev, [filter.id]: nextPage }));
  }, []);

  const onSearchChange = event => {
    setSearchTerm(event.target.value);
  };

  // Restart from page 1 only once typing settles, so each keystroke doesn't hit the API.
  useEffect(() => {
    setShouldRefetchFilter(true);
    if (openFilterId) {
      setPageInfo(prev => ({ ...prev, [openFilterId.id]: 1 }));
    }
  }, [debouncedSearchTerm]);

  const handleFilterClick = (event, filterId) => {
    setAnchorEl(event.currentTarget);
    setOpenFilterId(filterId);

    setShouldRefetchFilter(true);
    setIsAnyPopperOpen(prev => {
      if (!openFilterId?.id) {
        return true;
      } else if (prev && openFilterId?.id === filterId.id) {
        return false;
      } else if (prev && openFilterId?.id !== filterId.id) {
        return true;
      } else return !prev;
    });
    if (ignoreRedirectionFields?.includes(filterId.id)) return;
    setSearchTerm('');
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpenFilterId(null);
    setSearchTerm('');
    setShowSkeletonForNewFilter(false);
    setCurrentFilterKey(null);
    setIsPaginationLoading(false);
  };

  const handleClearSearch = event => {
    event.stopPropagation();
    setSearchTerm('');
  };

  useEffect(() => {
    if (isInventory && serviceCategoryList?.data && defaultValue?.services?.length > 0) {
      const serviceCategories = new Set();
      const resourceTypes = new Set();

      defaultValue.services.forEach(serviceName => {
        const category = serviceCategoryList.data.find(category =>
          category.service_category.services.some(service => service.service_name === serviceName),
        );

        if (category) {
          serviceCategories.add(category.service_category.category_name);
          const service = category.service_category.services.find(service => service.service_name === serviceName);
          if (service) {
            service.resource_types.forEach(type => resourceTypes.add(type));
          }
        }
      });

      setSelectedFilters(prev => {
        const updatedFilter = { ...prev };

        if (serviceCategories.size > 0) {
          const currentCategories = new Set(updatedFilter.service_category || []);
          serviceCategories.forEach(category => {
            if (!currentCategories.has(category)) {
              currentCategories.add(category);
            }
          });
          updatedFilter.service_category = Array.from(currentCategories);
        }

        if (resourceTypes.size > 0) {
          const currentResourceTypes = new Set(updatedFilter.resource_type || []);
          resourceTypes.forEach(type => {
            if (!currentResourceTypes.has(type)) {
              currentResourceTypes.add(type);
            }
          });
          updatedFilter.resource_type = Array.from(currentResourceTypes);
        }

        return updatedFilter;
      });
    }
  }, [isInventory, serviceCategoryList, defaultValue, setSelectedFilters]);

  useEffect(() => {
    if (isInventory && serviceCategoryList?.data && selectedFilters?.services?.length > 0) {
      const serviceCategories = new Set();
      const resourceTypes = new Set();

      selectedFilters.services.forEach(serviceName => {
        const category = serviceCategoryList.data.find(category =>
          category.service_category.services.some(service => service.service_name === serviceName),
        );

        if (category) {
          serviceCategories.add(category.service_category.category_name);
          const service = category.service_category.services.find(service => service.service_name === serviceName);
          if (service) {
            service.resource_types.forEach(type => resourceTypes.add(type));
          }
        }
      });

      setSelectedFilters(prev => {
        const updatedFilter = { ...prev };

        if (serviceCategories.size > 0) {
          const currentCategories = new Set(updatedFilter.service_category || []);
          serviceCategories.forEach(category => {
            if (!currentCategories.has(category)) {
              currentCategories.add(category);
            }
          });
          updatedFilter.service_category = Array.from(currentCategories);
        }

        if (resourceTypes.size > 0) {
          const currentResourceTypes = new Set(updatedFilter.resource_type || []);
          resourceTypes.forEach(type => {
            if (!currentResourceTypes.has(type)) {
              currentResourceTypes.add(type);
            }
          });
          updatedFilter.resource_type = Array.from(currentResourceTypes);
        }

        return updatedFilter;
      });
    }
  }, [isInventory, serviceCategoryList, selectedFilters?.services, setSelectedFilters]);

  // MODIFIED: getCurrentOptions with selected-first sorting
  const getCurrentOptions = filterId => {
    const options = filterData[filterId]?.data || option[filterOptions.find(f => f.id === filterId)?.label]?.data || [];

    // Handle risk_category special case with search
    if (fromRisk && filterId === 'risk_category') {
      if (searchTerm?.trim()) {
        return options.filter(o => o.toLowerCase().includes(searchTerm.toLowerCase()));
      }
    }

    // If search is active or feature is disabled, return unmodified results
    if (!enableSelectedFirst || searchTerm?.trim()) {
      return options;
    }

    // Sort: selected items first, then unselected in original order
    const selectedSet = new Set(selectedFilters[filterId] || []);
    const selected = [];
    const unselected = [];

    options.forEach(opt => {
      if (selectedSet.has(opt)) {
        selected.push(opt);
      } else {
        unselected.push(opt);
      }
    });

    return [...selected, ...unselected];
  };

  const handleFilterChange = (filterId, option, isChecked) => {
    setSelectedFilters(prev => {
      const updatedFilter = { ...prev };

      if (isChecked) {
        updatedFilter[filterId] = [...(updatedFilter[filterId] || []), option];
      } else {
        updatedFilter[filterId] = (updatedFilter[filterId] || []).filter(item => item !== option);
      }

      // Handle dependencies between service category, service, and resource type
      if (isInventory && serviceCategoryList?.data) {
        if (filterId === 'service_category') {
          if (isChecked) {
            const categoryData = serviceCategoryList.data.find(
              category => category.service_category.category_name === option,
            );

            if (categoryData) {
              const servicesInCategory = categoryData.service_category.services.map(service => service.service_name);
              const resourceTypesInCategory = categoryData.service_category.services.flatMap(
                service => service.resource_types,
              );

              updatedFilter.services = [
                ...(updatedFilter.services || []),
                ...servicesInCategory.filter(service => !updatedFilter.services?.includes(service)),
              ];

              updatedFilter.resource_type = [
                ...(updatedFilter.resource_type || []),
                ...resourceTypesInCategory.filter(type => !updatedFilter.resource_type?.includes(type)),
              ];
            }
          } else {
            const categoryData = serviceCategoryList.data.find(
              category => category.service_category.category_name === option,
            );

            if (categoryData) {
              const servicesInCategory = categoryData.service_category.services.map(service => service.service_name);

              const remainingServices = updatedFilter.services?.filter(service => {
                const serviceExistsInOtherCategories = serviceCategoryList.data.some(category => {
                  if (category.service_category.category_name === option) return false;
                  if (!updatedFilter.service_category?.includes(category.service_category.category_name)) return false;
                  return category.service_category.services.some(s => s.service_name === service);
                });

                return serviceExistsInOtherCategories || !servicesInCategory.includes(service);
              });

              updatedFilter.services = remainingServices || [];

              const resourceTypesInCategory = categoryData.service_category.services.flatMap(
                service => service.resource_types,
              );

              const remainingResourceTypes = updatedFilter.resource_type?.filter(type => {
                const typeExistsInOtherCategories = serviceCategoryList.data.some(category => {
                  if (category.service_category.category_name === option) return false;
                  if (!updatedFilter.service_category?.includes(category.service_category.category_name)) return false;
                  return category.service_category.services.some(s => s.resource_types.includes(type));
                });

                return typeExistsInOtherCategories || !resourceTypesInCategory.includes(type);
              });

              updatedFilter.resource_type = remainingResourceTypes || [];
            }
          }
        }

        if (filterId === 'services') {
          if (isChecked) {
            const serviceCategory = serviceCategoryList.data.find(category =>
              category.service_category.services.some(service => service.service_name === option),
            );

            if (serviceCategory) {
              const categoryName = serviceCategory.service_category.category_name;
              if (!updatedFilter.service_category?.includes(categoryName)) {
                updatedFilter.service_category = [...(updatedFilter.service_category || []), categoryName];
              }

              const serviceData = serviceCategory.service_category.services.find(
                service => service.service_name === option,
              );

              if (serviceData) {
                const resourceTypesForService = serviceData.resource_types;
                updatedFilter.resource_type = [
                  ...(updatedFilter.resource_type || []),
                  ...resourceTypesForService.filter(type => !updatedFilter.resource_type?.includes(type)),
                ];
              }
            }
          } else {
            const serviceCategory = serviceCategoryList.data.find(category =>
              category.service_category.services.some(service => service.service_name === option),
            );

            if (serviceCategory) {
              const categoryName = serviceCategory.service_category.category_name;
              const otherServicesInCategory = serviceCategory.service_category.services
                .filter(service => service.service_name !== option)
                .map(service => service.service_name);

              const anyOtherServiceSelected = otherServicesInCategory.some(service =>
                updatedFilter.services?.includes(service),
              );

              if (!anyOtherServiceSelected && updatedFilter.service_category?.includes(categoryName)) {
                updatedFilter.service_category = updatedFilter.service_category.filter(cat => cat !== categoryName);
              }

              const serviceData = serviceCategory.service_category.services.find(
                service => service.service_name === option,
              );

              if (serviceData) {
                const resourceTypesForService = serviceData.resource_types;
                const remainingResourceTypes = updatedFilter.resource_type?.filter(type => {
                  if (!resourceTypesForService.includes(type)) return true;

                  return serviceCategoryList.data.some(category => {
                    return category.service_category.services.some(service => {
                      if (service.service_name === option) return false;
                      if (!updatedFilter.services?.includes(service.service_name)) return false;
                      return service.resource_types.includes(type);
                    });
                  });
                });

                updatedFilter.resource_type = remainingResourceTypes || [];
              }
            }
          }
        }

        if (filterId === 'resource_type') {
          if (isChecked) {
            for (const category of serviceCategoryList.data) {
              for (const service of category.service_category.services) {
                if (service.resource_types.includes(option)) {
                  if (!updatedFilter.services?.includes(service.service_name)) {
                    updatedFilter.services = [...(updatedFilter.services || []), service.service_name];
                  }

                  const categoryName = category.service_category.category_name;
                  if (!updatedFilter.service_category?.includes(categoryName)) {
                    updatedFilter.service_category = [...(updatedFilter.service_category || []), categoryName];
                  }

                  break;
                }
              }
            }
          }
        }
      }

      if (updatedFilter[filterId]?.length === 0) {
        if (Array.isArray(updatedFilter[filterId])) {
          updatedFilter[filterId] = [];
        } else {
          updatedFilter[filterId] = '';
        }
      }

      return updatedFilter;
    });

    if (filterId?.toLowerCase() === 'services') {
      setInventoryTableBreadcrumb(prev => {
        return prev.filter(
          item => !(item.title?.toLowerCase().includes('aws') || item.title?.toLowerCase().includes('gcp')),
        );
      });
    }
  };

  useEffect(() => {
    if (!isEmpty(defaultValue)) {
      const initialFilters = {};
      Object.entries(defaultValue || {})?.map(([key, value]) => {
        initialFilters[key] = value;
      });
      setSelectedFilters(prev => ({ ...prev, ...initialFilters }));
      if (setIsDefaultValue) setIsDefaultValue(true);
    }
  }, [defaultValue, setIsDefaultValue, setSelectedFilters]);

  const clearFilter = filterId => {
    setSelectedFilters(prev => {
      const updatedFilter = { ...prev };
      if (Array.isArray(updatedFilter[filterId])) {
        updatedFilter[filterId] = [];
      } else {
        updatedFilter[filterId] = '';
      }
      return updatedFilter;
    });
    setOpenFilterId(null);
  };

  useEffect(() => {
    const handleClickOutside = event => {
      if (!isAnyPopperOpen) return;

      let isClickOutside = true;

      for (let i = 0; i < buttonRefs.current.length; i++) {
        const buttonRef = buttonRefs.current[i];
        if (buttonRef && buttonRef.contains(event.target)) {
          if (openFilterId && filterOptions[i]?.id === openFilterId.id) {
            return;
          }
          isClickOutside = false;
          break;
        }
      }

      if (isClickOutside && openFilterId) {
        const filterIndex = filterOptions.findIndex(filter => filter.id === openFilterId.id);
        if (filterIndex !== -1 && popperRefs.current[filterIndex]?.contains(event.target)) {
          isClickOutside = false;
        }
      }

      if (isClickOutside) {
        setIsAnyPopperOpen(false);
        setOpenFilterId(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isAnyPopperOpen, openFilterId, filterOptions]);

  const resetAllFilters = () => {
    if (onResetFilters) {
      onResetFilters();
      return;
    }

    const emptyFilters = {};
    Object.keys(selectedFilters).forEach(key => {
      emptyFilters[key] = Array.isArray(selectedFilters[key]) ? [] : '';
    });
    setSelectedFilters(emptyFilters);
  };

  // Drives the Reset button's visibility. Keys that always hold a value (a match mode, a default sort)
  // would read as "a filter is applied" forever, so an owner that has them can name the keys that
  // actually count; without the prop this stays as it was and looks at every key.
  const hasActiveFilters = (filterKeys ?? Object.keys(selectedFilters)).some(key => {
    const filter = selectedFilters[key];
    return Array.isArray(filter) ? filter.length > 0 : Boolean(filter);
  });

  if (!openFilter) return <></>;

  return (
    <div className="filter-component">
      <div className="filter-buttons">
        {filterOptions?.map((filter, index) => (
          <React.Fragment key={filter.id}>
            <Button
              variant="outlined"
              data-testid={`click-filter-button-${filter.id}`}
              data-clickable="true"
              ref={el => (buttonRefs.current[index] = el)}
              onClick={e => {
                handleFilterClick(e, filter);
              }}
              className="filter-button"
              style={{
                borderColor: selectedFilters[filter.id]?.length > 0 ? '#9362d9' : 'var(--border-color-light)',
              }}>
              {filter.label}
              {selectedFilters[filter.id]?.length > 0 && (
                <span className=""> : ({selectedFilters[filter.id].length})</span>
              )}
              <ChevronDown
                size={16}
                sx={{
                  transform: isAnyPopperOpen && openFilterId?.id === filter.id ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: 'transform 0.2s ease-in-out',
                }}
              />
            </Button>
            <Popper
              disablePortal={disablePortal}
              open={isAnyPopperOpen && openFilterId?.id === filter.id}
              sx={{
                backgroundColor: '#ffffff',
                color: '#1a202c',
                border: '1px solid var(--border-color-light)',
                boxShadow:
                  '0px 5px 5px -3px rgba(0,0,0,0.05),0px 8px 10px 1px rgba(0,0,0,0.05),2px 3px 14px 2px rgba(0,0,0,0.05)',
                borderRadius: '10px',
                overflow: 'hidden',
                // Its own width: with disablePortal the popper's containing block is .filter-buttons (fit-content, so
                // only as wide as the chips), which squeezed it down to the chip and cut the search field.
                width: 'max-content',
                minWidth: '240px',
                maxWidth: '450px',
                zIndex: `${zIndex} !important`,
                marginTop: '7px !important',
              }}
              modifiers={[
                {
                  name: 'preventOverflow',
                  enabled: true,
                  options: {
                    boundary: document.body,
                  },
                },
                {
                  name: 'flip',
                  enabled: true,
                },
                {
                  name: 'offset',
                  options: {
                    offset: [0, 7],
                  },
                },
                {
                  name: 'computeStyles',
                  options: {
                    gpuAcceleration: false,
                  },
                },
              ]}
              anchorEl={anchorEl}
              onClose={handleClose}
              ref={el => (popperRefs.current[index] = el)}
              className="CustomScrollbar"
              placement="bottom-start">
              <div style={{ padding: '10px 10px 0 10px' }}>
                <TextField
                  size="small"
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={e => {
                    onSearchChange(e);
                  }}
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon sx={{ fontSize: '18px', color: 'rgba(0, 0, 0, 0.54)' }} />
                      </InputAdornment>
                    ),
                    endAdornment: searchTerm && (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="clear search"
                          data-testid={`clear-search-button-${filter.id}`}
                          data-clickable="true"
                          onClick={e => {
                            handleClearSearch(e);
                          }}
                          edge="end"
                          size="small"
                          sx={{
                            padding: '2px',
                            '&:hover': {
                              backgroundColor: 'rgba(0, 0, 0, 0.04)',
                            },
                          }}>
                          <X sx={{ fontSize: '16px', color: 'rgba(0, 0, 0, 0.54)' }} />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: '13px',
                      fontFamily: 'Manrope',
                      '& fieldset': {
                        border: 'none',
                      },
                      '&:hover fieldset': {
                        border: 'none',
                      },
                      '&.Mui-focused fieldset': {
                        border: 'none',
                      },
                    },
                    '& .MuiOutlinedInput-input': {
                      padding: '8px 0px',
                    },
                    backgroundColor: 'rgb(249, 250, 251)',
                    borderRadius: '5px',
                  }}
                />
              </div>
              <div
                id={`scrollableDiv-${filter.id}`}
                style={{
                  marginTop: '10px',
                  maxHeight: '226px',
                  minWidth: '100px',
                  overflowY: 'auto',
                  maxWidth: '450px',
                }}>
                {showSkeletonForNewFilter || (isQueryLoading && getCurrentOptions(filter.id).length === 0) ? (
                  <Box display={'flex'} flexDirection={'column'} gap={'8px'} padding={'15px'}>
                    <Skeleton variant="rectangular" width={'100%'} height={'20px'} sx={{ borderRadius: '10px' }} />
                    <Skeleton variant="rectangular" width={'100%'} height={'20px'} sx={{ borderRadius: '10px' }} />
                    <Skeleton variant="rectangular" width={'100%'} height={'20px'} sx={{ borderRadius: '10px' }} />
                    <Skeleton variant="rectangular" width={'100%'} height={'20px'} sx={{ borderRadius: '10px' }} />
                  </Box>
                ) : getCurrentOptions(filter.id).length === 0 ? (
                  <div style={{ padding: '10px 20px' }}>
                    <NoData height="100px" />
                  </div>
                ) : (
                  <InfiniteScroll
                    dataLength={getCurrentOptions(filter.id).length}
                    next={() => {
                      const nextPage = (pageInfo[filter.id] || 1) + 1;
                      fetchMoreData(filter, nextPage);
                    }}
                    hasMore={hasMore[filter.id] || false}
                    loader={
                      <Box display="flex" justifyContent="center" padding="10px">
                        <CircularProgress size={20} />
                      </Box>
                    }
                    scrollableTarget={`scrollableDiv-${filter.id}`}>
                    <FormGroup>
                      {getCurrentOptions(filter.id).map(option => (
                        <FormControlLabel
                          className="CustomScrollbar"
                          sx={{
                            marginBottom: '0px',
                            marginRight: '0px',
                            padding: '0px 20px',
                            display: 'flex !important',
                            flexWrap: 'nowrap',
                            '.MuiTypography-root': {
                              fontFamily: 'Manrope',
                              fontSize: '13px',
                              fontWeight: '500',
                            },
                            '&:hover': {
                              backgroundColor: 'rgb(238,238,238)',
                            },
                            '&:active': {
                              backgroundColor: 'rgb(238,238,238)',
                            },
                          }}
                          key={option}
                          control={
                            <CheckBox
                              checked={
                                selectedFilters[filter.id]?.includes(option) ||
                                (!isBoolean(option) && selectedFilters[filter.id]?.includes(option)) ||
                                false
                              }
                              onChange={e => {
                                e.stopPropagation();
                                handleFilterChange(filter.id, option, e.target.checked);
                              }}
                            />
                          }
                          label={<FilterItemLabel option={option} filter={filter} />}
                        />
                      ))}
                    </FormGroup>
                  </InfiniteScroll>
                )}
              </div>
              <Box display={'flex'} justifyContent={'center'} margin={'7px'}>
                <Button
                  data-testid={`clear-filter-button-${filter.id}`}
                  data-clickable="true"
                  onClick={() => clearFilter(filter.id)}
                  className="clear-button"
                  sx={{
                    textTransform: 'none',
                    fontSize: '12px',
                    fontFamily: 'Manrope',
                    fontWeight: '500',
                    color: '#9362d9',
                    padding: '3px 8px',
                    borderRadius: '5px',
                  }}>
                  Clear
                </Button>
              </Box>
            </Popper>
          </React.Fragment>
        ))}
        {hasActiveFilters && (
          <ResetButton data-testid="click-reset-all-button" data-clickable="true" onClick={resetAllFilters} />
        )}
      </div>
      {totalCount && (
        <div
          style={{
            textWrap: 'nowrap',
            fontWeight: 500,
            marginRight: '15px',
            marginTop: '5px',
            fontSize: '14px',
            marginLeft: '10px',
          }}>
          Total: <span style={{ fontWeight: 600 }}>{totalCount}</span>
        </div>
      )}
    </div>
  );
};

const FilterItemLabel = React.memo(({ option, filter }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {active_risk_mapping[option] && filter.label?.toUpperCase()?.includes('RISK') && (
        <img src={active_risk_mapping[option]} style={{ marginRight: '7px', width: '18px', height: '18px' }} />
      )}
      {filter.label === 'Compliance Family' && (
        <ComplianceIconMapping name={option} width="20px" height="20px" style={{ marginRight: '5px' }} />
      )}
      {serviceGridIcons[option] && (
        <img src={serviceGridIcons[option]} style={{ marginRight: '5px', width: '20px', height: '20px' }} />
      )}
      {(filter.label === 'Services' || filter.label === 'Service') && (
        <div style={{ marginRight: '10px' }}>
          <AWSServiceIcons name={option} imgWidth={13} imgHeight={13} />
        </div>
      )}
      {filter.label === 'Country' && (
        <div style={{ marginRight: '10px' }}>
          <CountryFlagIcons isRounded={true} name={option} />
        </div>
      )}
      {(filter.label === 'Region' || filter.label === 'Regions') && (
        <div style={{ marginRight: '10px' }}>
          <RegionsFlagIcons isRounded={true} name={option} />
        </div>
      )}
      <Tooltip title={option}>
        <span
          className="SingleLine"
          style={{
            fontSize: '13px',
            fontFamily: 'Manrope',
            fontWeight: '500',
            maxWidth: '350px',
          }}>
          {typeof option === 'boolean' ? option.toString() : option}
        </span>
      </Tooltip>
    </div>
  );
});

export default PaginatedFilter;
